'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _sparkCore = require('@ciscospark/spark-core');

var _constants = require('../constants');

var _request = require('../meeting-info/request');

var _request2 = _interopRequireDefault(_request);

var _request3 = require('./request');

var _request4 = _interopRequireDefault(_request3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @class PersonalMeetingRoom
 */
var PersonalMeetingRoom = function (_StatelessSparkPlugin) {
  (0, _inherits3.default)(PersonalMeetingRoom, _StatelessSparkPlugin);

  /**
   *
   * @param {Object} attrs
   * @param {Object} options
   */
  function PersonalMeetingRoom(attrs, options) {
    (0, _classCallCheck3.default)(this, PersonalMeetingRoom);

    var _this = (0, _possibleConstructorReturn3.default)(this, (PersonalMeetingRoom.__proto__ || (0, _getPrototypeOf2.default)(PersonalMeetingRoom)).call(this, {}, options));

    _this.namespace = _constants.MEETINGS;

    _this.pmr = null;
    _this.sipUri = null;
    _this.link = null;
    _this.userId = null;
    _this.name = null;
    _this.meetingInfoRequest = new _request2.default({}, options);
    _this.personalMeetingRoomRequest = new _request4.default({}, options);
    return _this;
  }

  /**
   * claims a pmr and updates the cached PMR values
   * @param {String} link
   * @param {String} pin
   * @param {Boolean} preferred optional, defaults to true to set this claimed PMR as the preferred
   * @returns {Promise}
   * @memberof PersonalMeetingRoom
   */


  (0, _createClass3.default)(PersonalMeetingRoom, [{
    key: 'claim',
    value: function claim(link, pin) {
      var _this2 = this;

      var preferred = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      var options = {
        userId: this.spark.internal.device.userId,
        passcode: pin,
        meetingAddress: link,
        preferred: preferred
      };
      return this.personalMeetingRoomRequest.claimPmr(options).then(function (pmr) {
        if (pmr && pmr.body) {
          _this2.set(pmr.body);
        } else {
          return _promise2.default.reject(new Error('No PMR body provided. PMR values not updated.'));
        }
        return pmr.body;
      });
    }

    /**
     * @param {Object} body the response body from meeting info request
     * @returns {undefined}
     * @memberof PersonalMeetingRoom
     */

  }, {
    key: 'set',
    value: function set(body) {
      this.pmr = body;
      this.sipUri = body.sipMeetingUri;
      this.meetingLink = body.webExMeetingLink || body.meetingLink;
      this.userId = body.owner;
      this.name = body.meetingName;
      this.number = body.meetingNumber;
    }

    /**
     * TODO: implement TTL for syncing and caching so to not request again and again
     * @param {Object} options
     * @returns {Promise}
     * @memberof PersonalMeetingRoom
     */

  }, {
    key: 'get',
    value: function get() {
      var _this3 = this;

      var options = {
        type: _constants.PERSONAL_ROOM,
        destination: this.spark.internal.device.userId
      };
      return this.meetingInfoRequest.fetchMeetingInfo(options).then(function (pmr) {
        if (pmr && pmr.body && pmr.body.isPmr) {
          _this3.set(pmr.body);
        } else {
          return _promise2.default.reject(new Error('The PMR requested is NOT a PMR. PMR values not set.'));
        }
        return pmr.body;
      });
    }
  }]);
  return PersonalMeetingRoom;
}(_sparkCore.StatelessSparkPlugin);

exports.default = PersonalMeetingRoom;
//# sourceMappingURL=index.js.map
